import { SkuReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { SkuReportGridData } from '@pages/reporting-pages/deliveries-sku/types/SkuReportGridData';
import { getParsedSystemId } from '@utils/getParsedSystemId';
import { valueExist } from '@utils/typescriptGuards';



export const convertToGridData = (apiData: SkuReport[] | undefined | null): SkuReportGridData[] | null => {
	if (!apiData) return null;

	let gridData: SkuReportGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	
	for (const apiDataItem of apiData) {
		
		gridData.push({
			country: apiDataItem.country,
			materialId: apiDataItem.materialId,
			materialClientId: getParsedSystemId(apiDataItem.materialId).clientId,
			materialName: apiDataItem.materialName,
			totalVolume: valueExist(apiDataItem.totalVolume) ? apiDataItem.totalVolume : 0,
			onTradeVolume: valueExist(apiDataItem.onTradeVolume) ? apiDataItem.onTradeVolume : 0,
			offTradeVolume: valueExist(apiDataItem.offTradeVolume) ? apiDataItem.offTradeVolume : 0,
		});
	}

	return gridData;
}